import React from 'react';
import PropTypes from 'prop-types';

import classes from './DeletePlaceholderEmbed.scss';

class DeletePlaceholderEmbed extends React.Component {
  handleCancelClick = e => {
    this.props.onCancel(e);
  };

  render() {
    return (
      <div className={classes.wrapper}>
        <span className={classes.name}>
          <strong>{this.props.name}</strong> wird gelöscht…
        </span>
        <span className={classes.cancel}>
          <a
            className={classes.cancelButton}
            href="#abbrechen"
            onMouseDown={e => this.handleCancelClick(e)}
          >
            Abbrechen
          </a>
        </span>
      </div>
    );
  }
}
DeletePlaceholderEmbed.propTypes = {
  name: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
};
export default DeletePlaceholderEmbed;



// WEBPACK FOOTER //
// ./src/components/DeletePlaceholderEmbed/DeletePlaceholderEmbed.js